/* eslint-disable import/no-named-as-default-member */
import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import { getLocale } from '@/utils/local'

import { translationResource as resources } from './resource'

const initOptions = {
  resources,
  lng: getLocale() || 'en',
  returnObjects: true,
  fallbackLng: 'en',
  keySeparator: '.',
  interpolation: {
    escapeValue: false,
  },
  react: {
    bindI18n: 'loaded languageChanged',
    bindI18nStore: 'added',
    useSuspense: true,
  },
}

i18n.use(initReactI18next).init(initOptions)

export default i18n
